import { render, staticRenderFns } from "./RecoverVehicleForPolice.vue?vue&type=template&id=799dcc8a&scoped=true"
import script from "./RecoverVehicleForPolice.vue?vue&type=script&lang=js"
export * from "./RecoverVehicleForPolice.vue?vue&type=script&lang=js"
import style0 from "./RecoverVehicleForPolice.vue?vue&type=style&index=0&id=799dcc8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799dcc8a",
  null
  
)

export default component.exports